import Crud from '../components/Nonconformity/Crud.vue'
import View from '../components/Nonconformity/View.vue'
import Form from '../components/Nonconformity/Form.vue'

let routes =
{
    path: "/nonconformities",
    component: resolve => require(["../components/layout/App"], resolve),
    children: [
        {
            path: "/nonconformities",
            name: "Não Conformidades",
            component: Crud
        },
        {
            path: "/nonconformities/view/:id",
            name: "Detalhes da Não Conformidade",
            component: View
        },
        {
            path: "/nonconformities/create",
            name: "Criar Não Conformidade",
            component: Form
        },
        {
            path: "/nonconformities/edit/:id",
            name: "Editar Não Conformidade",
            component: Form
        }
    ]
}


export default routes;


// WEBPACK FOOTER //
// ./src/router/nonconformity.js